import styles from '../HelpGuide.module.css';

// One line of Guide text. A [Label] is drawn as a copy of the app's button (H4): a styled
// span with no role, no tab stop and no handler, so it is read as plain text and never
// offered as a button.
export default function GuideText({ text }: { text: string }) {
  // split with a capture group alternates text and label: odd indexes are labels
  const parts = text.split(/\[([^\]]+)\]/);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <span key={i} className={styles.buttonCopy}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </>
  );
}
